module.exports = __webpack_public_path__ + "assets/9dda2f0d1f430e45a8ef8a8941f85a98.mp4";